import { Global } from '@emotion/react';
import styled from '@emotion/styled';
import { Box, CssBaseline } from '@mui/material';
import { GlobalStyle } from '../../global.style';
import { getColor } from './UICommon';
import { FC } from 'react';

const MainRoot = styled(Box)`
  background-color: ${getColor('DARK_CREAM')};
`;

interface StyleProviderProps {
  children?: React.ReactNode;
}

export const StyleProvider: FC<StyleProviderProps> = ({ children }) => {
  return (
    <MainRoot>
      <CssBaseline />
      <Global styles={GlobalStyle} />
      {children}
    </MainRoot>
  );
};
